import type { SourceResult } from './ChangeLog';

export const getSourceString = (
	source: { type: string; name?: string },
	translateFn: (key: string) => string
): SourceResult => {
	if (!source?.type) {
		return null;
	}

	if (source.type === 'trigger') {
		return `${translateFn('default.viaTrigger')}${source.name ? ` (${source.name})` : ''}`;
	}

	if (source.type === 'multi-action') {
		return `${translateFn('default.viaMultiAction')}`;
	}

	if (source?.type === 'merge') {
		return `${translateFn('auditLog.viaMerge')}${source.name ? ` (${source.name})` : ''}`;
	}

	if (source.type === 'import') {
		return `${translateFn('default.viaImport')}${
			source.name ? ` (${translateFn('default.importId')}: ${source.name})` : ''
		}`;
	}

	if (source.type === 'prospecting') {
		return translateFn('default.viaProspecting');
	}

	if (source.type === 'automation') {
		const text = source.name
			? `${translateFn('admin.automation')}: ${source.name}`
			: translateFn('admin.automation');
		return { text, hideUser: true };
	}

	return null;
};
